import { normalizeAnalyticsConfigValue } from '@/analytics/analytics-config-value';

export interface AnalyticsRuntimeEnvironment {
  nodeEnv: string | undefined;
  googleAnalyticsMeasurementId: string | undefined;
  clarityProjectId: string | undefined;
}

export interface AnalyticsRuntimeConfig {
  googleAnalyticsMeasurementId: string | null;
  clarityProjectId: string | null;
}

export function resolveAnalyticsRuntimeConfig(
  environment: AnalyticsRuntimeEnvironment
): AnalyticsRuntimeConfig {
  if (environment.nodeEnv !== 'production') {
    return {
      googleAnalyticsMeasurementId: null,
      clarityProjectId: null,
    };
  }

  return {
    googleAnalyticsMeasurementId: normalizeAnalyticsConfigValue(
      environment.googleAnalyticsMeasurementId
    ),
    clarityProjectId: normalizeAnalyticsConfigValue(
      environment.clarityProjectId
    ),
  };
}

function readAnalyticsRuntimeConfig() {
  return resolveAnalyticsRuntimeConfig({
    nodeEnv: process.env.NODE_ENV,
    googleAnalyticsMeasurementId: process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID,
    clarityProjectId: process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID,
  });
}

export function resolveGoogleAnalyticsMeasurementId() {
  return readAnalyticsRuntimeConfig().googleAnalyticsMeasurementId;
}

export function resolveClarityProjectId() {
  return readAnalyticsRuntimeConfig().clarityProjectId;
}
